import { JSX } from 'react'

import { IconProps } from '../../icon'

const UserValidation: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.4579 16.6968C37.5747 16.5305 37.7578 16.4037 37.9687 16.3433C38.1796 16.2829 38.4017 16.2935 38.5882 16.3729C38.7746 16.4523 38.9109 16.5944 38.9682 16.769C39.0255 16.9437 38.9993 17.1373 38.8952 17.309L35.9049 23.1005C35.8504 23.1893 35.7765 23.2693 35.6879 23.3359C35.5992 23.4025 35.4975 23.4541 35.3889 23.4878C35.2803 23.5216 35.167 23.5366 35.0557 23.5321C34.9445 23.5276 34.8376 23.5036 34.7415 23.4616L31.174 21.9028C31.076 21.8639 30.99 21.8076 30.9212 21.7372C30.8523 21.6668 30.8021 21.5838 30.7733 21.493C30.7446 21.4023 30.7381 21.3057 30.754 21.209C30.77 21.1124 30.8082 21.0176 30.8663 20.9304C30.9244 20.8433 31.0013 20.7654 31.0923 20.7016C31.1834 20.6377 31.2867 20.5891 31.3961 20.5588C31.5056 20.5284 31.6189 20.5168 31.7294 20.5248C31.8399 20.5328 31.9452 20.56 32.0391 20.6051L34.8621 21.8378L37.4432 16.7228C37.4479 16.7138 37.4532 16.705 37.459 16.6965L37.4579 16.6968Z'
      fill='black'
    />
    <path
      d='M18.8431 24.3431C21.7004 24.3431 24.0147 22.0288 24.0147 19.1715C24.0147 16.3143 21.7004 14 18.8431 14C15.9858 14 13.6716 16.3143 13.6716 19.1715C13.6716 22.0288 15.9858 24.3431 18.8431 24.3431ZM18.8431 16.5858C20.2653 16.5858 21.4289 17.7494 21.4289 19.1715C21.4289 20.5937 20.2653 21.7573 18.8431 21.7573C17.4209 21.7573 16.2573 20.5937 16.2573 19.1715C16.2573 17.7494 17.4209 16.5858 18.8431 16.5858Z'
      fill='black'
    />
    <path
      d='M18.8431 25.6359C15.3911 25.6359 8.5 27.3684 8.5 30.8075V34.6861H29.1862V30.8075C29.1862 27.3684 22.2951 25.6359 18.8431 25.6359ZM26.6004 32.1004H11.0858V30.8204C11.3443 29.8895 15.3523 28.2217 18.8431 28.2217C22.3339 28.2217 26.3418 29.8895 26.6004 30.8075V32.1004Z'
      fill='black'
    />
    <path
      d='M24.674 14.0647C25.8635 15.4352 26.6004 17.2193 26.6004 19.1716C26.6004 21.1238 25.8635 22.908 24.674 24.2785C27.2081 23.9553 29.1862 21.8091 29.1862 19.1716C29.1862 16.5341 27.2081 14.3879 24.674 14.0647Z'
      fill='black'
    />
    <path
      d='M29.8714 26.7091C31.0221 27.7822 31.7719 29.1268 31.7719 30.8075V34.6862H34.3577V30.8075C34.3577 28.9328 32.302 27.5624 29.8714 26.7091Z'
      fill='black'
    />
  </svg>
)

export default UserValidation
